import React, { useEffect } from "react";
import hiasan1 from "../../Img/hiasan-3.webp";
import bg12 from "../../Img/bg12.webp"; // Background utama tetap

// 👇 IMPORT ASET BARU 👇
import iconGereja from "../../Img/church.webp";
import iconResepsi from "../../Img/monumen.webp";
import jth1 from "../../Img/jth1.webp";
import jth2 from "../../Img/jth2.webp";
import jth3 from "../../Img/jth3.webp";
import jth4 from "../../Img/jth4.webp";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapLocationDot,
  faClock,
  faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Acara() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  // Tampung 4 variasi kelopak mawar dalam array
  const kelopakMawar = [jth1, jth2, jth3, jth4];

  return (
    <>
      <style>
        {`
          .acara-section {
            position: relative;
            background-image: url(${bg12});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-attachment: scroll; /* PERBAIKAN: Ubah fixed jadi scroll agar performa Mobile tidak lag/patah-patah */
            overflow: hidden;
            width: 100%;
          }

          /* 👇 Animasi Kelopak Mawar Jatuh 👇 */
          .falling-petal {
            position: absolute;
            top: -50px;
            animation: fallPetal linear infinite;
            pointer-events: none;
            z-index: 0; 
          }

          @keyframes fallPetal {
            0% { transform: translateY(0) rotate(0deg); opacity: 0; }
            10% { opacity: 1; }
            90% { opacity: 1; }
            100% { transform: translateY(105vh) rotate(720deg); opacity: 0; }
          }

          .arial-font {
            font-family: Arial, Helvetica, sans-serif;
          }
        `}
      </style>

      {/* PERBAIKAN RUANG KOSONG: Menambahkan pb-32 (padding-bottom ekstra) agar saat di-scroll mentok, tombol Map naik melewati batas BottomBar */}
      <div
        id="acara"
        className="acara-section pt-20 pb-32 md:pb-24 px-4 relative"
      >
        {/* 👇 GENERATOR KELOPAK MAWAR JATUH (HIDUP) 👇 */}
        {[...Array(20)].map((_, i) => {
          const randomImagePath =
            kelopakMawar[Math.floor(Math.random() * kelopakMawar.length)];

          return (
            <img
              key={i}
              src={randomImagePath}
              alt="kelopak mawar"
              className="falling-petal"
              style={{
                left: `${Math.random() * 100}%`,
                width: `${15 + Math.random() * 20}px`,
                animationDuration: `${6 + Math.random() * 4}s`,
                animationDelay: `${Math.random() * 10}s`,
                transform: `rotate(${Math.random() * 360}deg)`,
              }}
            />
          );
        })}

        {/* Header Section */}
        <div className="flex flex-col items-center mb-16 relative z-10">
          <img
            src={hiasan1}
            data-aos="zoom-in"
            alt="hiasan"
            className="w-[70px] mb-6"
          />
          <h1
            data-aos="fade-up"
            className="text-center text-4xl md:text-5xl font-semibold custom-font-3 mb-4 text-[#d6982e]"
          >
            Waktu & Lokasi
          </h1>
          <div className="w-24 h-1 bg-[#d6982e] rounded-full"></div>
        </div>

        {/* 👇 KONTEN KEGIATAN 👇 */}
        {/* Pastikan z-10 ditambahkan di container ini agar berada di atas kelopak mawar */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 relative z-10 mb-16">
          {/* CARD 1: PEMBERKATAN */}
          <div
            className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-gray-100 flex flex-col items-center transform transition-all duration-300 hover:scale-105"
            data-aos="fade-right"
          >
            <img
              src={iconGereja}
              alt="Icon Gereja"
              className="w-20 h-20 mb-6 object-contain"
            />

            <h2 className="text-4xl font-bold custom-font-2 text-[#d6982e] mb-1">
              Pemberkatan
            </h2>
            <p className="text-gray-500 uppercase tracking-widest text-xs mb-6 arial-font font-bold">
              Holy Matrimony
            </p>

            <div className="w-full border-t border-gray-100 my-4"></div>

            {/* Waktu */}
            <div className="flex items-center gap-3 mb-4 text-[#31261d]">
              <FontAwesomeIcon
                icon={faCalendarAlt}
                className="text-[#d6982e] text-lg"
              />
              <p className="arial-font font-semibold text-lg">
                Sabtu, 4 April 2026
              </p>
            </div>

            <div className="w-full border-t border-gray-100 my-4"></div>

            {/* Lokasi */}
            <div className="text-center text-gray-700 arial-font flex flex-col items-center gap-2">
              <p className="font-bold text-xl text-[#31261d]">GBI BETLEHEM</p>
              <p className="text-sm max-w-xs">Malang, Jawa Timur</p>
            </div>
          </div>

          {/* CARD 2: RESEPSI */}
          <div
            className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-gray-100 flex flex-col items-center transform transition-all duration-300 hover:scale-105"
            data-aos="fade-left"
          >
            <img
              src={iconResepsi}
              alt="Icon Resepsi"
              className="w-20 h-20 mb-6 object-contain"
            />

            <h2 className="text-4xl font-bold custom-font-2 text-[#d6982e] mb-1">
              Resepsi
            </h2>
            <p className="text-gray-500 uppercase tracking-widest text-xs mb-6 arial-font font-bold">
              Wedding Reception
            </p>

            <div className="w-full border-t border-gray-100 my-4"></div>

            {/* Waktu */}
            <div className="flex flex-col gap-3 mb-4 text-[#31261d] items-center">
              <div className="flex items-center gap-3">
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  className="text-[#d6982e] text-lg"
                />
                <p className="arial-font font-semibold text-lg">
                  Sabtu, 11 April 2026
                </p>
              </div>
              <div className="flex items-center gap-3">
                <FontAwesomeIcon
                  icon={faClock}
                  className="text-[#d6982e] text-lg"
                />
                <p className="arial-font font-semibold text-lg">
                  12.30 - 14.00 WIB
                </p>
              </div>
            </div>

            <div className="w-full border-t border-gray-100 my-4"></div>

            {/* Lokasi */}
            <div className="text-center text-gray-700 arial-font flex flex-col items-center gap-2">
              <p className="font-bold text-xl text-[#31261d]">Grha Lestari</p>
              <p className="text-sm max-w-xs">Tulungagung, Jawa Timur</p>
            </div>
          </div>
        </div>

        {/* 👇 Peta Lokasi 👇 */}
        {/* Tambahkan z-20 agar iframe map dan tombol 100% interaktif dan tidak terhalang mawar jatuh */}
        <div className="flex justify-center relative mx-2 z-20">
          <div
            data-aos="fade-up"
            className="w-full max-w-4xl bg-white p-4 rounded-3xl shadow-2xl"
          >
            <div className="mapouter">
              <div className="gmap_canvas">
                <iframe
                  title="maps"
                  className="gmap_iframe rounded-2xl"
                  width="100%"
                  height="350px"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src="https://maps.google.com/maps?q=Grha%20Lestari%20Tulungagung&t=&z=15&ie=UTF8&iwloc=&output=embed"
                ></iframe>
              </div>
            </div>

            <div className="flex justify-center pt-6 pb-2">
              {/* PERBAIKAN LINK DAN AREA KLIK */}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://maps.app.goo.gl/9TBpV25xFDQXhp6S9"
                className="text-white text-md bg-[#d6982e] hover:bg-[#b57f23] active:scale-95 transition-all duration-300 font-bold rounded-xl px-7 py-4 flex items-center gap-3 shadow-lg cursor-pointer"
              >
                <FontAwesomeIcon icon={faMapLocationDot} className="text-xl" />
                Buka Peta Lokasi Resepsi
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
